import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class WebCommonErrorHandler implements ErrorHandler {
  constructor(private loggerService: LoggerService) {}

  handleError(error: any): void {
    this.loggerService.logError(error);
  }
}
